/* Deck builder — the Variety Box and Bundle & Save pages.
   State is a map of variant id -> quantity. Everything on screen (steppers,
   box slots, the bar) is redrawn from that map, so there is one source of
   truth and no way for the slots and the counts to disagree.
   The saving shown here is a preview; Shopify's automatic discounts are what
   actually price the order (see sections/deck-builder.liquid). */
(function () {
  function money(c) {
    if (window.TOMSCart && window.TOMSCart.money) return window.TOMSCart.money(c);
    return '$' + (c / 100).toFixed(2);
  }

  function init(root) {
    var mode = root.dataset.mode;
    var tiers = (root.dataset.tiers || '').split(',').filter(Boolean).map(function (t) {
      var p = t.split(':');
      return { qty: Number(p[0]), pct: Number(p[1]) };
    }).sort(function (a, b) { return a.qty - b.qty; });

    var grid = root.querySelector('[data-deck-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-deck]'));
    cards.forEach(function (c, i) { c.dataset.order = i; });
    var byId = {};
    cards.forEach(function (c) { byId[c.dataset.variantId] = c; });

    var boxVariants = {};
    (root.dataset.boxVariants || '').split(',').filter(Boolean).forEach(function (x) {
      var p = x.split(':');
      boxVariants[Number(p[0])] = { id: Number(p[1]), available: p[2] === '1' };
    });
    var qty = {};
    var boxSize = mode === 'box' && tiers.length ? tiers[0].qty : 0;
    var picks = []; /* box mode: variant ids in the order picked, for the slots */

    var slots = root.querySelector('[data-slots]');
    var msg = root.querySelector('[data-deck-msg]');
    var was = root.querySelector('[data-deck-was]');
    var now = root.querySelector('[data-deck-now]');
    var go = root.querySelector('[data-deck-go]');
    var tray = root.querySelector('[data-tray]');
    var LOCK = '<svg viewBox="0 0 12 14" aria-hidden="true"><rect x="1" y="6" width="10" height="8" rx="1.5" fill="currentColor"/><path d="M3.5 6V4a2.5 2.5 0 0 1 5 0v2" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
    var TICK = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6.5l2.5 2.5L10 3.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    /* How many slots to draw: through the next locked saving, but never
       fewer than the second tier, so two thresholds are in sight from the
       start (3 and 6), then 12 once 6 is reached. Past the top tier the tray
       simply grows with the bundle. */
    function traySize(n) {
      if (!tiers.length) return Math.max(n, 6);
      var floor = tiers[Math.min(1, tiers.length - 1)].qty;
      var next = tiers.filter(function (t) { return t.qty > n; })[0];
      return Math.max(floor, next ? next.qty : n);
    }

    function drawTray(n) {
      if (!tray) return;
      var size = traySize(n);
      var html = '';
      for (var i = 0; i < size; i++) {
        var id = picks[i];
        var tier = tiers.filter(function (t) { return t.qty === i + 1; })[0];
        var cls = 'deckb__slot' + (id ? ' is-full' : '') + (tier ? ' is-tier' : '') + (tier && n >= tier.qty ? ' is-unlocked' : '');
        html += '<li class="' + cls + '">';
        if (id) {
          var c = byId[id];
          html += '<button type="button" data-slot-remove="' + id + '" aria-label="Remove ' + c.dataset.name.replace(/"/g, '&quot;') + '">' +
            (c.dataset.img ? '<img src="' + c.dataset.img + '" alt="">' : '') + '</button>';
        }
        if (tier) {
          html += '<span class="deckb__lock">' + (n >= tier.qty ? TICK : LOCK) + tier.pct + '% off</span>';
        }
        if (!id && !tier) html += '<span class="visually-hidden">Empty</span>';
        html += '</li>';
      }
      tray.innerHTML = html;
      /* The slots share the bar's width (no sideways scroll): one row of up
         to 12 on desktop, then further rows as the bundle grows. */
      tray.style.setProperty('--cols', Math.min(size, 12));
      var label = root.querySelector('[data-deck-count]');
      if (label) label.textContent = n ? ' · ' + n + (n === 1 ? ' deck' : ' decks') : '';
    }

    function count() {
      var n = 0;
      for (var k in qty) n += qty[k];
      return n;
    }

    function subtotal() {
      var s = 0;
      for (var k in qty) s += qty[k] * Number(byId[k].dataset.price);
      return s;
    }

    function nextTierQty(n) {
      var next = tiers.filter(function (t) { return t.qty > n; })[0];
      return next ? next.qty : 0;
    }

    function tierFor(n) {
      var hit = null;
      tiers.forEach(function (t) { if (n >= t.qty) hit = t; });
      return hit;
    }

    function set(id, n) {
      var card = byId[id];
      var max = Math.min(Number(card.dataset.max) || 99, 99);
      if (n > max) n = max;
      if (n < 0) n = 0;
      var diff = n - (qty[id] || 0);
      if (mode === 'box' && diff > 0 && count() + diff > boxSize) return false;
      if (n) qty[id] = n; else delete qty[id];
      if (diff > 0) { for (var i = 0; i < diff; i++) picks.push(id); }
      if (diff < 0) {
        for (var j = 0; j < -diff; j++) {
          var at = picks.lastIndexOf(id);
          if (at > -1) picks.splice(at, 1);
        }
      }
      return true;
    }

    function draw() {
      var n = count();
      var sub = subtotal();

      cards.forEach(function (c) {
        var q = qty[c.dataset.variantId] || 0;
        /* The box picker always shows its stepper (theory11: − 0 +); the
           bundle picker swaps a button for the stepper once a deck is in. */
        c.querySelector('[data-deck-add]').hidden = mode === 'box' || q > 0;
        c.querySelector('[data-deck-step]').hidden = mode !== 'box' && q === 0;
        c.querySelector('[data-deck-qty]').textContent = q;
        c.classList.toggle('is-in', q > 0);
        var full = mode === 'box' && n >= boxSize;
        c.querySelector('[data-deck-add]').disabled = full;
        c.querySelector('[data-deck-plus]').disabled = full || q >= (Number(c.dataset.max) || 99);
        c.querySelector('[data-deck-minus]').disabled = q === 0;
      });

      var pct = 0;
      if (mode === 'box') {
        var sizeTier = tiers.filter(function (t) { return t.qty === boxSize; })[0];
        pct = n === boxSize && sizeTier ? sizeTier.pct : 0;
        if (n < boxSize) {
          msg.textContent = (boxSize - n) + ' more to fill your box' + (sizeTier ? ' · ' + sizeTier.pct + '% off' : '');
        } else {
          msg.textContent = 'Box full' + (sizeTier ? ' · ' + sizeTier.pct + '% off at checkout' : '');
        }
        var bx = boxVariants[boxSize];
        go.disabled = n !== boxSize || (bx && !bx.available);
        if (bx && !bx.available) msg.textContent = 'The ' + boxSize + '-deck box is out of stock right now.';

        slots.innerHTML = '';
        for (var i = 0; i < boxSize; i++) {
          var li = document.createElement('li');
          li.className = 'deckb__slot';
          var id = picks[i];
          if (id) {
            li.classList.add('is-full');
            var b = document.createElement('button');
            b.type = 'button';
            b.dataset.slotRemove = id;
            b.setAttribute('aria-label', 'Remove ' + byId[id].dataset.name);
            if (byId[id].dataset.img) {
              var im = document.createElement('img');
              im.src = byId[id].dataset.img; im.alt = '';
              b.appendChild(im);
            }
            li.appendChild(b);
          } else {
            li.innerHTML = '<span aria-hidden="true">+</span><span class="visually-hidden">Empty slot</span>';
          }
          slots.appendChild(li);
        }
        root.querySelectorAll('[data-box-size]').forEach(function (btn) {
          btn.setAttribute('aria-checked', Number(btn.dataset.boxSize) === boxSize ? 'true' : 'false');
        });
      } else {
        var t = tierFor(n);
        pct = t ? t.pct : 0;
        var next = tiers.filter(function (x) { return x.qty > n; })[0];
        if (n === 0) {
          msg.textContent = next ? 'Add ' + next.qty + ' decks to unlock ' + next.pct + '% off' : 'Pick your decks';
        } else if (next) {
          msg.textContent = t ? t.pct + '% off unlocked · ' + (next.qty - n) + ' more for ' + next.pct + '%' : 'Add ' + (next.qty - n) + ' more to unlock ' + next.pct + '% off';
        } else {
          msg.textContent = pct + '% off unlocked — applied at checkout';
        }
        go.disabled = n === 0;
        root.querySelectorAll('[data-deck-random]').forEach(function (b) { b.disabled = !next; });
        root.querySelectorAll('[data-tier]').forEach(function (el) {
          el.classList.toggle('is-on', n >= Number(el.dataset.tier));
        });
      }

      var total = Math.round(sub * (100 - pct) / 100);
      now.textContent = n ? money(total) : money(0);
      was.hidden = !(pct && n);
      was.textContent = money(sub);
      root.classList.toggle('has-picks', n > 0);
      drawTray(n);
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-deck]');
      if (card) {
        var id = card.dataset.variantId;
        if (e.target.closest('[data-deck-add]') || e.target.closest('[data-deck-plus]')) {
          set(id, (qty[id] || 0) + 1); draw(); return;
        }
        if (e.target.closest('[data-deck-minus]')) { set(id, (qty[id] || 0) - 1); draw(); return; }
      }

      var rm = e.target.closest('[data-slot-remove]');
      if (rm) { var rid = rm.dataset.slotRemove; set(rid, (qty[rid] || 0) - 1); draw(); return; }

      var size = e.target.closest('[data-box-size]');
      if (size) {
        boxSize = Number(size.dataset.boxSize);
        /* Shrinking the box drops the most recent picks, never the first ones. */
        while (count() > boxSize) { var last = picks[picks.length - 1]; set(last, qty[last] - 1); }
        draw(); return;
      }

      if (e.target.closest('[data-deck-clear]')) { qty = {}; picks = []; draw(); return; }

      var rnd = e.target.closest('[data-deck-random]');
      if (rnd && !rnd.disabled) {
        /* Fill the empty slots with decks not already in the box where possible.
           A bundle has no slots to fill, so it is topped up to the next saving. */
        var target = mode === 'box' ? boxSize : nextTierQty(count());
        if (!target) return;
        var pool = cards.filter(function (c) { return !qty[c.dataset.variantId]; });
        if (!pool.length) pool = cards.slice();
        for (var k = pool.length - 1; k > 0; k--) {
          var r = Math.floor(Math.random() * (k + 1)); var tmp = pool[k]; pool[k] = pool[r]; pool[r] = tmp;
        }
        var guard = 0;
        while (count() < target && guard < 500) {
          var c = pool[guard % pool.length];
          set(c.dataset.variantId, (qty[c.dataset.variantId] || 0) + 1);
          guard++;
        }
        draw(); return;
      }

      var goBtn = e.target.closest('[data-deck-go]');
      if (goBtn && !goBtn.disabled) {
        var items = Object.keys(qty).map(function (id) { return { id: Number(id), quantity: qty[id] }; });
        var bx = mode === 'box' ? boxVariants[boxSize] : null;
        if (bx) {
          /* One code per box, on the box and on every deck in it, so two boxes
             in one order can still be packed apart. Visible on the order. */
          var code = 'VB-' + Math.random().toString(36).slice(2, 6).toUpperCase();
          items.forEach(function (it) { it.properties = { 'Variety box': code }; });
          items.unshift({ id: bx.id, quantity: 1, properties: { 'Variety box': code, 'Decks': String(boxSize) } });
        }
        if (!window.TOMSCart) return;
        window.TOMSCart.addItems(items, goBtn).then(function (cart) {
          if (cart) { qty = {}; picks = []; draw(); }
        });
      }
    });

    var sort = root.querySelector('[data-deck-sort]');
    if (sort) sort.addEventListener('change', function () {
      var v = sort.value;
      var list = cards.slice().sort(function (a, b) {
        if (v === 'price-asc') return a.dataset.price - b.dataset.price || a.dataset.order - b.dataset.order;
        if (v === 'price-desc') return b.dataset.price - a.dataset.price || a.dataset.order - b.dataset.order;
        if (v === 'name') return a.dataset.name.localeCompare(b.dataset.name);
        return a.dataset.order - b.dataset.order;
      });
      list.forEach(function (c) { grid.appendChild(c); });
    });

    draw();
  }

  function boot() {
    document.querySelectorAll('[data-deck-builder]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
